import Image from 'next/image';
import styles from './scss/location.module.scss';
import { useState, useEffect } from 'react';
import { apiGetAddressApiKey, apiGetAddressURL } from "../config/index"
import axios from 'axios';
import { setUserLocation } from '../store/reducer/compareproduct';
import { useDispatch, useSelector } from 'react-redux';
import CustomDropdown from './component/dropdown';

export default function ChooseLocation({ onCloseModal }) {
    const dispatch = useDispatch();
    const userLocation = useSelector((state) => state.compareproduct.userLocation);
    const [locationAccessDenied, setLocationAccessDenied] = useState(false);
    const [userDetails, setUserDetails] = useState({
        postcode: "",
        address: "",
        latitude: "",
        longitude: "",
        isAllowLocation: false,
        message: "",
        fullAddress: ""
    })
    const [addressList, setAddressList] = useState([]);
    const [checkPostalValidation, setCheckPostalValidation] = useState(false);
    const [checkAddressValidation, setCheckAddressValidation] = useState(false);
    const [isApplyDisabled, setIsApplyDisabled] = useState(true);
    const [manualEntry, setManualEntry] = useState(false);
    const [findbtn, setFindBtn] = useState(true);
    console.log("findbtn::??", findbtn);

    useEffect(() => {
        if (userLocation?.postcode) {
            setUserDetails((prev) => ({
                postcode: userLocation.postcode ?? '',
                address: userLocation.address ?? '',
                latitude: userLocation.latitude ?? '',
                longitude: userLocation.longitude ?? '',
                isAllowLocation: userLocation.isAllowLocation ?? false,
                message: userLocation.message ?? '',
                fullAddress: userLocation.fullAddress ?? ''
            }));
        }
    }, [userLocation?.postcode]);

    console.log("userLocation:::", userLocation);

    console.log("userDetails:::", userDetails);
    console.log("addressList:::", addressList);

    console.log("navigator:::", navigator);

    const handleApplyAddress = async () => {
        setCheckAddressValidation(true);
        if (userDetails?.postcode === '' || userDetails?.address === '') return;
        console.log("userDetails:::>>>", userDetails);
        if (userDetails?.fullAddress?.country_code) {
            dispatch(setUserLocation({ ...userDetails }));
        } else {
            const addressFromCoords = await getAddressFromCoords(userDetails?.latitude, userDetails?.longitude);
            dispatch(setUserLocation({ ...userDetails, fullAddress: addressFromCoords?.address ?? "" }));
        }
        onCloseModal();
    }

    const handlePickLocationClick = () => {
        if (!navigator.geolocation) {
            setUserDetails((prev) => ({
                ...prev,
                message: "Geolocation is not supported by your browser."
            }));
            return;
        }

        navigator.geolocation.getCurrentPosition(
            async (position) => {
                const { latitude, longitude } = position.coords;
                const addressFromCoords = await getAddressFromCoords(latitude, longitude);

                setUserDetails((prev) => ({
                    ...prev,
                    latitude,
                    longitude,
                    postcode: addressFromCoords?.address?.postcode ?? "",
                    address: addressFromCoords?.display_name ?? "",
                    isAllowLocation: true,
                    message: "",
                    fullAddress: addressFromCoords?.address ?? "",
                }));
                setLocationAccessDenied(false);
                setIsApplyDisabled(false);
            },
            (error) => {
                console.error("Geolocation error:", error);
                setLocationAccessDenied(true);
                setUserDetails((prev) => ({
                    postcode: "",
                    address: "",
                    latitude: "",
                    longitude: "",
                    message: "",
                    isAllowLocation: false,
                    message: "",
                    fullAddress: ""
                }));
                dispatch(setUserLocation({ ...userDetails }));
            }
        );

    };


    // const findMyAddress = () => {
    //     try {
    //         setCheckPostalValidation(true);
    //         if (userDetails?.postcode === '') {
    //             setUserDetails({
    //                 postcode: "",
    //                 address: "",
    //                 latitude: "",
    //                 longitude: "",
    //                 fullAddress: ""
    //             })
    //             setAddressList([])
    //             return
    //         }
    //         setFindBtn(true)
    //         axios.get(`${apiGetAddressURL}${userDetails?.postcode?.trim()}?api-key=${apiGetAddressApiKey}`)
    //             .then((response) => {
    //                 if (response?.data?.Addresses && response?.data?.Addresses?.length > 0) {
    //                     setUserDetails({ ...userDetails, latitude: response?.data?.Latitude, longitude: response?.data?.Longitude, message: response?.data?.Message })
    //                     setAddressList(response?.data?.Addresses?.map((item) => ({ value: item.replace(/,/g, ""), name: item.replace(/,/g, "") })))
    //                     setIsApplyDisabled(false);
    //                 }
    //             })
    //             .catch((error) => {
    //                 setUserDetails({
    //                     postcode: userDetails?.postcode,
    //                     address: "",
    //                     latitude: "",
    //                     longitude: "",
    //                     message: "Please enter a valid UK postcode (e.g., W1A 1AA).",
    //                     fullAddress: ""
    //                 })
    //                 setAddressList([])
    //                 console.log(error)
    //             });
    //     } catch (error) {
    //         console.log(error)
    //     }
    // }

    // const getAddressFromCoords = async (lat, lng) => {
    //     const url = `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lng}`;

    //     try {
    //         const response = await fetch(url, {
    //             headers: {
    //                 "User-Agent": "YourAppName/1.0 (your-email@example.com)", // Replace with your app's name and contact email
    //             },
    //         });
    //         if (!response.ok) {
    //             throw new Error("Failed to fetch address");
    //         }
    //         const data = await response.json();
    //         console.log("data:::", data);
    //         return data || "Address not found";
    //     } catch (error) {
    //         console.error("Error fetching address:", error);
    //         return null;
    //     }
    // }

    const findMyAddress = async () => {
        try {
          setCheckPostalValidation(true);
          const postcode = userDetails?.postcode?.trim();
      
          if (!postcode) {
            setUserDetails({
              postcode: "",
              address: "",
              latitude: "",
              longitude: "",
              fullAddress: "",
              message: "",
            });
            setAddressList([]);
            setIsApplyDisabled(true);
            return;
          }
      
          setFindBtn(true);
      
          const res = await axios.get(`/api/get-address?postcode=${encodeURIComponent(postcode)}`);
      
          if (res.status === 200 && Array.isArray(res.data) && res.data.length > 0) {
            setUserDetails({
              ...userDetails,
              latitude: res.data[0]?.latitude || "",
              longitude: res.data[0]?.longitude || "",
              message: "",
            });
      
            const addresses = res.data.map((item) => ({
              value: item.summaryline || "",
              name: item.summaryline || "",
            }));
      
            setAddressList(addresses);
            setIsApplyDisabled(false);
          } else {
            setUserDetails({
              ...userDetails,
              address: "",
              message: "No addresses found for this postcode.",
            });
            setAddressList([]);
            setIsApplyDisabled(true);
          }
        } catch (error) {
          console.log(error);
          setUserDetails({
            ...userDetails,
            address: "",
            message: "Please enter a valid postal code.",
          });
          setAddressList([]);
          setIsApplyDisabled(true);
        }
      };
      

    const getAddressFromCoords = async (lat, lng) => {
        const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=AIzaSyCGu7n5gPpKuN44D-D90aDyCI084esoo9A`;

        try {
            const response = await fetch(url);
            const result = await response.json();
            console.log("result:::???", result);
            const streetAddress = result?.results?.find(add => add?.types.includes('street_address')) || result?.results?.find(add => add?.types.includes('postal_code'));
            console.log("streetAddress:::???", streetAddress);
            const postalCodeComponent = streetAddress?.address_components?.find(address => address.types.includes('postal_code'));
            const countryComponent = streetAddress?.address_components?.find(address => address.types.includes('country'));
            let addressFromCoords = {};
            addressFromCoords.display_name = streetAddress?.formatted_address;
            addressFromCoords.address = {
                postcode: postalCodeComponent?.long_name,
                country: countryComponent?.long_name,
                country_code: countryComponent?.short_name
            }
            console.log("addressFromCoords:::???", addressFromCoords);
            return addressFromCoords || {};
        } catch (error) {
            console.error("Error fetching address:", error);
            return null;
        }
    }



    return (
        <>
            <div className={styles.location}>
                <h3>Choose your location<svg onClick={onCloseModal} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M9.20122 7.99906L15.0562 2.14356C15.3882 1.81246 15.3882 1.27346 15.0562 0.942359C14.7242 0.610359 14.1851 0.610359 13.855 0.942359L8.00002 6.79776L2.14502 0.942359C1.81492 0.610359 1.27392 0.610359 0.943824 0.942359C0.611824 1.27346 0.611824 1.81246 0.943824 2.14356L6.79882 7.99906L0.943824 13.8546C0.611824 14.1857 0.611824 14.7247 0.943824 15.0558C1.10982 15.2218 1.32662 15.3048 1.54442 15.3048C1.76222 15.3048 1.97992 15.2218 2.14502 15.0558L8.00002 9.20036L13.855 15.0558C14.02 15.2218 14.2378 15.3048 14.4556 15.3048C14.6734 15.3048 14.8902 15.2218 15.0562 15.0558C15.3882 14.7247 15.3882 14.1857 15.0562 13.8546L9.20122 7.99906Z" fill="black" />
                </svg></h3>

                {
                    (!locationAccessDenied || manualEntry) ? (
                        <>
                            <p>Explore the best deals and offers available in your area. </p>
                            <div className={styles.locationbody}>
                                {/* Postal and address input section */}

                                <div className={styles.fieldareamain}>
                                    <div className={styles.label}>Postal Code</div>
                                    <div className={styles.fieldareamainhalf}>
                                        <input
                                            type="text"
                                            name="postcode"
                                            placeholder="(e.g., W1A 1AA)"
                                            value={userDetails.postcode}
                                            onChange={(e) => {
                                                setFindBtn(false)
                                                setCheckAddressValidation(false);
                                                setUserDetails({ ...userDetails, postcode: e.target.value, address: "", addressList: [], message: "", fullAddress: "" });
                                                setIsApplyDisabled(true);
                                            }}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    e.preventDefault();
                                                    findMyAddress();
                                                }
                                            }}
                                        />
                                        {!isApplyDisabled && <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                            <path d="M10 0.28125C4.4771 0.28125 0 4.75835 0 10.2812C0 15.8041 4.4772 20.2812 10 20.2812C15.5228 20.2812 20 15.8039 20 10.2812C20 4.75855 15.5228 0.28125 10 0.28125ZM14.7787 7.49735L10.2518 13.3928C9.8539 13.9114 9.2513 14.2297 8.5985 14.2678C8.555 14.2708 8.5111 14.2717 8.4676 14.2717C7.8607 14.2717 7.2786 14.0276 6.8529 13.5891L5.2782 11.967C4.9896 11.6701 4.9965 11.1945 5.2938 10.9065C5.5911 10.6185 6.0663 10.6262 6.3543 10.9221L7.929 12.5442C8.0833 12.7024 8.2806 12.7874 8.5115 12.7709C8.7322 12.7582 8.9275 12.6546 9.0623 12.4788L13.5892 6.58335C13.8412 6.25525 14.3138 6.19375 14.6405 6.44565C14.9691 6.69765 15.0311 7.16825 14.7787 7.49735Z" fill="#28A745" />
                                        </svg>}
                                        <button className={` ${findbtn ? styles.disabled : ""}`} onClick={findMyAddress}>Find</button>
                                    </div>
                                </div>

                                {checkPostalValidation && userDetails.postcode === '' && <p className="errors">Please enter postal code</p>}
                                {userDetails.message && <p className="errors">{userDetails.message}</p>}

                                {!isApplyDisabled && addressList?.length > 0 && (
                                    <div className={styles.fieldareamain}>
                                        <CustomDropdown
                                            label="Select Address"
                                            options={addressList}
                                            value={userDetails?.address}
                                            onSelect={(val) => {
                                                setUserDetails({ ...userDetails, address: val, message: "" })}}
                                        />
                                    </div>
                                )}
                                {checkAddressValidation && addressList?.length > 0 && userDetails?.address === '' && <p className="errors">Please select address</p>}

                                {isApplyDisabled && <p className={styles.locationfetch}>{userDetails?.address}</p>}
                                {!manualEntry && (
                                    <div className={styles.picklocation} onClick={handlePickLocationClick}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M10.0181 0.671875C9.60399 0.671875 9.26809 1.00778 9.26809 1.42188V2.67867C9.26809 3.09277 9.60399 3.42867 10.0181 3.42867C10.4322 3.42867 10.7681 3.09277 10.7681 2.67867V1.42188C10.7681 1.00778 10.4322 0.671875 10.0181 0.671875Z" fill="#7454FF" />
                                            <path d="M10.0181 16.5684C9.60399 16.5684 9.26809 16.9043 9.26809 17.3184V18.5762C9.26809 18.9903 9.60399 19.3262 10.0181 19.3262C10.4322 19.3262 10.7681 18.9903 10.7681 18.5762V17.3184C10.7681 16.9043 10.4322 16.5684 10.0181 16.5684Z" fill="#7454FF" />
                                            <path d="M2.67819 9.12498H1.42139C1.00729 9.12498 0.671387 9.46088 0.671387 9.87498C0.671387 10.2891 1.00729 10.625 1.42139 10.625H2.67819C3.09229 10.625 3.42819 10.2891 3.42819 9.87498C3.42819 9.46088 3.09229 9.12498 2.67819 9.12498Z" fill="#7454FF" />
                                            <path d="M18.5786 9.12498H17.3208C16.9067 9.12498 16.5708 9.46088 16.5708 9.87498C16.5708 10.2891 16.9067 10.625 17.3208 10.625H18.5786C18.9927 10.625 19.3286 10.2891 19.3286 9.87498C19.3286 9.46088 18.9927 9.12498 18.5786 9.12498Z" fill="#7454FF" />
                                            <path d="M9.99979 5.35818C12.5584 5.35818 14.6402 7.43988 14.6402 9.99868C14.6402 12.5575 12.5584 14.6391 9.99979 14.6391C7.44119 14.6391 5.35939 12.5574 5.35939 9.99868C5.35939 7.43998 7.44119 5.35818 9.99979 5.35818ZM9.99979 3.85818C6.60869 3.85818 3.85939 6.60738 3.85939 9.99868C3.85939 13.39 6.60869 16.1391 9.99979 16.1391C13.3909 16.1391 16.1402 13.3899 16.1402 9.99868C16.1402 6.60748 13.3912 3.85818 9.99979 3.85818Z" fill="#7454FF" />
                                            <path d="M10.0175 8.94348C10.6 8.94348 11.0741 9.41698 11.0741 9.99907C11.0741 10.5812 10.6 11.0547 10.0175 11.0547C9.43549 11.0547 8.96209 10.5812 8.96209 9.99907C8.96209 9.41698 9.43549 8.94348 10.0175 8.94348ZM10.0175 7.44348C8.60859 7.44348 7.46209 8.59008 7.46209 9.99907C7.46209 11.4081 8.60859 12.5547 10.0175 12.5547C11.4274 12.5547 12.5741 11.4081 12.5741 9.99907C12.5741 8.59008 11.4274 7.44348 10.0175 7.44348Z" fill="#7454FF" />
                                        </svg>or use my current location
                                    </div>
                                )}
                            </div>

                            <div className={styles.locationfooter}>
                                <button onClick={handleApplyAddress} disabled={isApplyDisabled}
                                    style={{
                                        backgroundColor: isApplyDisabled ? '#e0e0e0' : '#7454FF',
                                        color: isApplyDisabled ? '#aaa' : '#fff',
                                        cursor: isApplyDisabled ? 'not-allowed' : 'pointer'
                                    }}
                                >
                                    Apply
                                </button>
                            </div>
                        </>
                    ) : (
                        <>
                            <div className={`${styles.locationbody} ${styles.locationbodydenied}`}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="41" viewBox="0 0 40 41" fill="none">
                                    <path d="M20 40.7734C8.9542 40.7734 0 31.8188 0 20.7734C0 9.72804 8.9542 0.773438 20 0.773438C31.0458 0.773438 40 9.72764 40 20.7734C40 31.8192 31.0456 40.7734 20 40.7734ZM20 30.6904C20.827 30.6904 21.4974 30.0204 21.4974 29.1934C21.4974 28.3664 20.827 27.6964 20 27.6964C19.173 27.6964 18.5026 28.3664 18.5026 29.1934C18.5026 30.0204 19.1728 30.6904 20 30.6904ZM21.513 10.8554C21.513 10.0272 20.8412 9.35544 20.013 9.35544C19.1848 9.35544 18.513 10.0272 18.513 10.8554V24.3612C18.513 25.1894 19.1848 25.8612 20.013 25.8612C20.8412 25.8612 21.513 25.1894 21.513 24.3612V10.8554Z" fill="#DE003D" />
                                </svg>
                                <h4>Access Denied</h4>
                                <p>You’ve denied location access. To proceed, manually enter your location or try again.</p>
                            </div>
                            <div className={styles.locationfooter}>
                                <button
                                    className={styles.cancel}
                                    onClick={() => setManualEntry(true)}
                                >
                                    Enter Manually
                                </button>
                            </div>
                        </>
                    )
                }


            </div>
        </>
    );
}
